(() => {
  const dialog = document.querySelector('[data-mtm-products-dialog]');
  if (!dialog) return;
  const triggers = [...document.querySelectorAll('[data-mtm-products-open]')];
  const categories = dialog.querySelector('[data-mtm-products-categories]');
  const controllerLevel = dialog.querySelector('[data-mtm-products-controller-level]');
  const controllerButton = dialog.querySelector('[data-mtm-products-controllers]');
  let opener = null;
  let previousOverflow = '';
  const level = (controllers, focus = false) => {
    categories.hidden = controllers;
    controllerLevel.hidden = !controllers;
    controllerButton.setAttribute('aria-expanded', String(controllers));
    if (focus) (controllers ? dialog.querySelector('[data-mtm-products-level-title]') : (!controllerButton.hidden ? controllerButton : categories.querySelector('.mtm-products-card:not([hidden])') || dialog.querySelector('[data-mtm-products-close]'))).focus();
  };
  const open = (trigger, controllers = false) => {
    if (dialog.open) return;
    opener = trigger;
    level(controllers && !controllerButton.hidden);
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.showModal();
    triggers.forEach(button => button.setAttribute('aria-expanded', 'true'));
  };
  triggers.forEach(trigger => trigger.addEventListener('click', () => open(trigger)));
  controllerButton.addEventListener('click', () => level(true, true));
  dialog.querySelector('[data-mtm-products-back]').addEventListener('click', () => level(false, true));
  dialog.querySelector('[data-mtm-products-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('close', () => {
    document.body.style.overflow = previousOverflow;
    triggers.forEach(button => button.setAttribute('aria-expanded', 'false'));
    if (opener && opener.isConnected) opener.focus();
  });
  document.querySelectorAll('[data-mtm-controller-open]').forEach(trigger => {
    trigger.addEventListener('click', event => {
      event.preventDefault();
      event.stopImmediatePropagation();
      open(trigger, true);
    }, true);
  });
  document.querySelectorAll('.mtm-v2-category-nav a[href="/pages/controllers"]').forEach(link => {
    link.addEventListener('click', event => {
      event.preventDefault();
      open(link, true);
    });
  });
})();

(() => {
  const dialog = document.querySelector('[data-mtm-products-dialog]');
  if (!dialog) return;
  const scopes = new Set(['racing-wheels','controllers','gaming-furniture','gaming-accessories','audio']);
  const scopeFor = node => {
    if (node.hasAttribute('data-mtm-products-controllers')) return 'controllers';
    try {
      const url = new URL(node.getAttribute('href'), location.origin);
      const category = url.pathname.replace(/^\/pages\//,'');
      if (!scopes.has(category)) return '';
      const subgroup = url.searchParams.get('subgroup');
      return category === 'controllers' && subgroup ? 'controllers-' + subgroup : category;
    } catch { return ''; }
  };
  const entries = [...dialog.querySelectorAll('.mtm-products-card'), ...document.querySelectorAll('.mtm-v2-category-nav a'), ...document.querySelectorAll('[data-mtm-controller-group]')];
  entries.forEach(node => { const scope = scopeFor(node); if (scope) { node.dataset.mtmProductScope = scope; node.hidden = true; } });
  const notice = document.createElement('p');
  notice.setAttribute('role','status');
  notice.textContent = 'Loading available products…';
  dialog.querySelector('[data-mtm-products-categories]').prepend(notice);
  const retry = document.createElement('button');
  retry.type = 'button'; retry.className = 'mtm-products-back'; retry.textContent = 'Try again'; retry.hidden = true;
  retry.addEventListener('click', () => { retry.hidden = true; notice.textContent = 'Loading available products…'; document.dispatchEvent(new Event('mtm-products-refresh')); });
  notice.after(retry);
  const validItem = item => {
    if (!item || typeof item.title !== 'string' || !item.title.trim() || !Array.isArray(item.bullets) || !item.bullets.length) return false;
    try { const url = new URL(item.imageUrl); return url.protocol === 'https:' && url.hostname === 'static.wixstatic.com'; } catch { return false; }
  };
  const apply = data => {
    if (!data || !Array.isArray(data.categories)) return;
    const counts = new Map(data.categories.map(category => [category.category, category.enabled === true ? (Array.isArray(category.items) ? category.items.filter(validItem).length : 0) : 0]));
    const controllerScopes = new Set(entries.map(node => node.dataset.mtmProductScope).filter(scope => scope?.startsWith('controllers-')));
    const controllerCount = [...controllerScopes].filter(scope => (counts.get(scope) || 0) > 0).length;
    counts.set('controllers', controllerCount);
    entries.forEach(node => { const scope = node.dataset.mtmProductScope; if (scope) node.hidden = !(counts.get(scope) > 0); });
    const controllerButton = dialog.querySelector('[data-mtm-products-controllers]');
    const label = controllerButton.querySelector('small');
    if (label?.firstChild) label.firstChild.textContent = controllerCount + ' · ' + controllerButton.querySelector('strong').textContent + ' ';
    const visibleFamilies = [...dialog.querySelector('[data-mtm-products-categories] nav').children].filter(node => !node.hidden).length;
    const intro = dialog.querySelector('[data-mtm-products-categories] .mtm-products-intro p');
    if (intro) intro.hidden = true;
    notice.hidden = visibleFamilies > 0;
    notice.textContent = 'No products are currently published.';
    retry.hidden = true;
    if (!controllerCount && !dialog.querySelector('[data-mtm-products-controller-level]').hidden) {
      dialog.querySelector('[data-mtm-products-categories]').hidden = false;
      dialog.querySelector('[data-mtm-products-controller-level]').hidden = true;
      controllerButton.setAttribute('aria-expanded','false');
      if (dialog.open) dialog.querySelector('[data-mtm-products-close]').focus();
    }
  };
  document.addEventListener('mtm-highlights-ready', event => apply(event.detail));
  document.addEventListener('mtm-highlights-error', () => {
    if (window.mtmPublishedHighlights) return;
    notice.hidden = false; notice.textContent = 'Products could not be loaded. Please try again.'; retry.hidden = false;
  });
  if (window.mtmPublishedHighlights) apply(window.mtmPublishedHighlights);
})();
